var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100vh","background":"#f7f9fa"},attrs:{"id":"app"}},[(!_vm.show)?_c('index'):_vm._e(),(_vm.show)?_c('indexMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }